export const APIKeys = process.env.VUE_APP_ARCGIS;
export const baseURL = "https://api.v2.salt.releaf.ng/api/v2/";
// export const baseURL = "http://localhost:3000/api/v2/";

